import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_14 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_15 = { class: "mt-4 has-text-centered" }
const _hoisted_16 = {
  key: 2,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_17 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isEmailFilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: "https://i.imgur.com/uA3fRLZ.png",
                      class: "image",
                      alt: "logo"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", {
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmEmail && _ctx.confirmEmail(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Schedule appointment", -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datetime) = $event)),
                            class: "input",
                            id: "schedule",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.datetime,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "help" }, "Insert the appointment date and time", -1))
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Your email", -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                            class: "input",
                            type: "email",
                            placeholder: "vet@doctor.com",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.email,
                              void 0,
                              {
                                trim: true,
                                lazy: true
                              }
                            ]
                          ])
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "help" }, "Insert your registered email", -1))
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("button", {
                        type: "submit",
                        class: "mt-5 button is-primary is-fullwidth"
                      }, "Confirm appointment", -1))
                    ], 32)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.isConfirming)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[10] || (_cache[10] = [
                      _createStaticVNode("<div data-v-40e79a68><img src=\"https://i.imgur.com/uA3fRLZ.png\" class=\"image\" alt=\"logo\" data-v-40e79a68></div><div class=\"mt-5\" data-v-40e79a68><span class=\"fa fa-spinner fa-spin has-text-grey-light fa-6x\" data-v-40e79a68></span></div><div class=\"mt-4 has-text-centered\" data-v-40e79a68><p class=\"is-size-5\" data-v-40e79a68> Confirming appointment... </p></div>", 3)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.isConfirming && !_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          src: "https://i.imgur.com/uA3fRLZ.png",
                          class: "image",
                          alt: "logo"
                        })
                      ], -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-5" }, [
                        _createElementVNode("span", { class: "fa fa-times-circle has-text-danger fa-6x" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "is-size-5" }, " Cant activate this appointment! ", -1)),
                        _createElementVNode("button", {
                          class: "button is-warning mt-5",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                        }, "Check inserted email")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[15] || (_cache[15] = _createStaticVNode("<div data-v-40e79a68><img src=\"https://i.imgur.com/uA3fRLZ.png\" class=\"image\" alt=\"logo\" data-v-40e79a68></div><div class=\"mt-5\" data-v-40e79a68><span class=\"fa fa-check has-text-success fa-6x\" data-v-40e79a68></span></div><div class=\"mt- has-text-centered\" data-v-40e79a68><p class=\"is-size-5\" data-v-40e79a68> Appointment confirmed </p><p class=\"has-text-grey\" data-v-40e79a68> An email has been sent to you and the user with access details. </p></div>", 3)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_router_link, {
                            to: _ctx.appointmentURL,
                            class: "button is-primary"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("Access appointment")
                            ])),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ])
  ]))
}